import { definitions } from 'api/generated/photo'

export const slicedPhotos = (
  photos: definitions['OmniAlbumPhoto'][],
  selectedPhotoIndex: number
): definitions['OmniAlbumPhoto'][] => {
  const leftPhoto =
    selectedPhotoIndex !== 0
      ? photos[selectedPhotoIndex - 1]
      : photos[photos.length - 1]
  const rightPhoto =
    selectedPhotoIndex !== photos.length - 1
      ? photos[selectedPhotoIndex + 1]
      : photos[0]
  return [leftPhoto, photos[selectedPhotoIndex], rightPhoto]
}
